var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.8096 22C18.3318 22 23.6191 17.0751 23.6191 11C23.6191 4.92487 18.3318 0 11.8096 0C5.28732 0 0 4.92487 0 11C0 17.0751 5.28732 22 11.8096 22Z",
    fill: "#FF6875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6244 7.70711L15.8652 7L7.51462 14.7782L8.27377 15.4853L16.6244 7.70711Z",
    fill: "#FF4252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8649 15.4849L16.624 14.7778L8.27341 6.99966L7.51426 7.70676L15.8649 15.4849Z",
    fill: "#FF4252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.dccfdad7e89bb22892d04e86344201e5.svg";
export { ForwardRef as ReactComponent };